import React from 'react';
import { useHistory } from 'react-router-dom';
import { SettingsPage } from '../contexts/settings-modal-context';
import { openKeycloakChangePassword } from '../utils/keycloak-utils';
import { pageToTabParam } from '../utils/settings-utils';

interface TabItem {
  page: SettingsPage;
  label: string;
}

interface SettingsTabsProps {
  tabs: TabItem[];
  activeTab: SettingsPage;
  basePath: string;
  onTabChange?: (page: SettingsPage) => void;
  hasUnsavedChanges?: boolean;
  onUnsavedChangesWarning?: (nextPage: SettingsPage) => void;
}

export const SettingsTabs: React.FC<SettingsTabsProps> = ({
  tabs,
  activeTab,
  basePath,
  onTabChange,
  hasUnsavedChanges = false,
  onUnsavedChangesWarning,
}) => {
  const history = useHistory();

  const handleTabClick = (page: SettingsPage) => {
    if (page === SettingsPage.changePassword) {
      openKeycloakChangePassword();
      return;
    }

    if (hasUnsavedChanges && onUnsavedChangesWarning) {
      onUnsavedChangesWarning(page);
      return;
    }

    const tabParam = pageToTabParam(page);
    history.push(`${basePath}?tab=${tabParam}`);

    if (onTabChange) {
      onTabChange(page);
    }
  };

  return (
    <div className="border-b border-neutral-200 bg-white">
      <div className="overflow-x-auto">
        <div className="flex min-w-full space-x-1 px-4">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.page;
            return (
              <button
                key={tab.page}
                onClick={() => handleTabClick(tab.page)}
                className={`font-open-sans whitespace-nowrap border-b-2 px-4 py-3 text-sm font-medium leading-6 transition-colors ${
                  isActive
                    ? 'border-primary text-primary'
                    : 'hover:text-primary text-section-header-slate hover:border-section-header-slate border-transparent'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
